const state = {
    isShow: false,
    isShowOnLiulanqi: false,
};
const getters = {
    isShow(state) {
        return state.isShow;
    },
    isShowOnLiulanqi(state) {
        return state.isShowOnLiulanqi;
    }
};
const mutations = {
    setShow(state, isShow) {
        state.isShow = isShow;
    },
    setShowOnLiulanqi(state, isShow) {
        state.isShowOnLiulanqi = isShow;
    },
};
const actions = {
    onShow(context, isShow) {
        let ua = navigator.userAgent.toLowerCase()
        if (/(Android)/i.test(navigator.userAgent) && isWeixinBrowser()) {
            //android
            context.commit('setShowOnLiulanqi',true)
        } else {
            context.commit('setShow', isShow);
        }
        function isWeixinBrowser() {
            return /micromessenger/.test(ua) ? true : false
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
